module.exports = __webpack_public_path__ + "media/images/responsive/articles/logo_sola-ca3aaa67707ed09d57fb80af860d75d1.svg";